import { useState } from "react";
import { createTicket } from "../../firebase/services";
import { Btn, CategoryPills, Textarea } from "../../components/UI";

const CATEGORIES = ["Plomberie", "Électricité", "Serrure / porte", "Climatisation", "Autre"];
const CATEGORY_ICONS = { Plomberie:"🔧", "Électricité":"⚡", "Serrure / porte":"🔑", Climatisation:"❄️", Autre:"⚙️" };

export default function StudentNewTicket({ roomId, userId, userName, onBack, onSuccess }) {
  const [category, setCategory] = useState("Plomberie");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async () => {
    if (!description.trim() || !roomId) return;
    setSubmitting(true);
    await createTicket(roomId, { category, description: description.trim(), userId, userName });
    setSubmitting(false);
    setDone(true);
  };

  // GARDE : impossible de créer un ticket sans chambre associée
  if (!roomId) return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>←</button>
        <span style={styles.headerTitle}>Signaler un problème</span>
      </div>
      <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:28, textAlign:"center" }}>
        <div style={{ fontSize:40, marginBottom:12 }}>🏠</div>
        <p style={{ fontSize:16, fontWeight:700, color:"#8a4c00", margin:"0 0 8px" }}>Aucune chambre associée</p>
        <p style={{ fontSize:14, color:"#7a90a8", lineHeight:1.6 }}>
          Votre compte n'est rattaché à aucune chambre. Contactez IAM Business Group pour être associé à votre logement avant de signaler un problème.
        </p>
      </div>
    </div>
  );

  if (done) return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>←</button>
        <span style={styles.headerTitle}>Ticket envoyé</span>
      </div>
      <div style={styles.successWrap}>
        <div style={styles.successIcon}>✓</div>
        <h2 style={styles.successTitle}>Ticket créé avec succès</h2>
        <p style={styles.successSub}>IAM Business Group a été notifié. Vous recevrez une réponse bientôt.</p>
        <div style={{ padding: "0 24px", marginTop: 24 }}>
          <Btn variant="primary" onClick={() => onSuccess()}>Voir mes tickets</Btn>
        </div>
      </div>
    </div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack} aria-label="Retour">←</button>
        <span style={styles.headerTitle}>Signaler un problème</span>
      </div>

      <div style={styles.scroll}>
        <div style={styles.formWrap}>
          {/* Category */}
          <p style={styles.label}>Catégorie du problème</p>
          <div style={styles.catGrid}>
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setCategory(cat)}
                style={{ ...styles.catCard, ...(category === cat ? styles.catCardActive : {}) }}
              >
                <span style={{ fontSize: 24 }}>{CATEGORY_ICONS[cat]}</span>
                <span style={{ fontSize: 11, fontWeight: 600, color: category === cat ? "#1a3a5c" : "#5a7a9a", textAlign: "center" }}>
                  {cat}
                </span>
              </button>
            ))}
          </div>

          {/* Description */}
          <p style={styles.label}>Description du problème</p>
          <textarea
            style={styles.textarea}
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder={`Ex: Le robinet du lavabo fuit en permanence depuis ce matin...`}
            rows={5}
          />
          <p style={styles.hint}>{description.length}/300 caractères</p>

          {/* Photo hint */}
          <div style={styles.photoHint}>
            <span style={{ fontSize: 16 }}>📷</span>
            <p style={{ fontSize: 12, color: "#5a7a9a", margin: 0 }}>
              Vous pourrez envoyer une photo via la messagerie après avoir soumis le ticket.
            </p>
          </div>

          {/* Submit */}
          <div style={{ marginTop: 20 }}>
            <Btn
              variant="primary"
              onClick={handleSubmit}
              disabled={!description.trim() || submitting}
            >
              {submitting ? "Envoi en cours..." : "📤 Envoyer le ticket"}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: { display: "flex", flexDirection: "column", height: "100%", background: "#f5f8fc", fontFamily: "'Barlow', sans-serif" },
  header: { background: "#1a3a5c", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10 },
  backBtn: { background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer", padding: "0 8px 0 0" },
  headerTitle: { fontSize: 15, fontWeight: 700, color: "white" },
  scroll: { flex: 1, overflowY: "auto" },
  formWrap: { padding: "20px 16px" },
  label: { fontSize: 13, fontWeight: 600, color: "#2a4a6a", marginBottom: 10 },
  catGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 20 },
  catCard: { background: "white", border: "1.5px solid #d0dce8", borderRadius: 12, padding: "12px 6px", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, cursor: "pointer", fontFamily: "inherit" },
  catCardActive: { background: "#e3f1fb", borderColor: "#2e86c1" },
  textarea: { width: "100%", border: "1.5px solid #d0dce8", borderRadius: 12, padding: "12px", fontSize: 14, fontFamily: "inherit", background: "#f7fafd", color: "#1a2a3a", resize: "none", outline: "none", boxSizing: "border-box" },
  hint: { fontSize: 11, color: "#aab8c8", textAlign: "right", margin: "4px 0 16px" },
  photoHint: { display: "flex", alignItems: "center", gap: 10, background: "#e3f1fb", borderRadius: 10, padding: "10px 12px" },
  successWrap: { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24 },
  successIcon: { width: 64, height: 64, borderRadius: "50%", background: "#e8f5e0", color: "#2d6a0a", fontSize: 30, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 },
  successTitle: { fontSize: 20, fontWeight: 800, color: "#1a3a5c", marginBottom: 8, fontFamily: "'Barlow Condensed', sans-serif" },
  successSub: { fontSize: 14, color: "#5a7a9a", textAlign: "center", lineHeight: 1.6 },
};
